/* eslint-disable max-len */
import { SvgIcon, colors } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import { noop } from 'lodash';
import * as React from 'react';

const Source: React.FC<CustomSvgIcon> = ({
    id = '',
    className = '',
    iconColor = `${colors.common.black}`,
    onClick = noop
}) => {
    return (
        <SvgIcon
            className={className}
            id={id}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 14 10'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Source</title>
                <g>
                    <path
                        d='M4.194 2.501L0.297 4.472V5.408L4.194 7.379V6.281L1.467 4.94L4.194 3.608V2.501ZM4.689 9.746H5.526L9.324 1.997H8.487L4.689 9.746ZM9.80677 7.379L13.7038 5.417V4.481L9.80677 2.51V3.599L12.5338 4.94L9.80677 6.281V7.379Z'
                        fill={iconColor}
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};

export default Source;